<template>
  <div class="page-conten">
    <p class="message" v-if="!greatness.length">
      {{ $t('nao-ha-registros-de-grandeza') }} </p>
    <div class="sample1 grid middle"></div>

    <div class="row gridBtGroup rowItem" xl="1" lg="3" md="3" sm="3">
      <img
        src="@/assets/plus.png"
        :alt="$t('adicionar-grandeza')"
        style="margin-left: 30px; height=38px"
        :title="$t('adicionar')"
        @click="askAddGreatness()"
      />
    </div>

    <b-modal
      id="addingGreatness"
      size="xl"
      hide-footer
      :title="$t('cadastro-de-grandeza')"
      :no-close-on-backdrop="true"
    >
      <FormGreatness :data="record" :newData="setNewData"></FormGreatness>
    </b-modal>

    <b-modal
      id="confirmDeleteData"
      ok-variant="danger"
      :ok-title="$t('yes')"
      :cancel-title="$t('no')"
      @ok="deleteGreatness(temp)"
      >{{ $t('deseja-excluir-a-s-grandeza-s') }}</b-modal
    >

    <b-modal
      id="DeletionNotAllowed"
      size="md"
      hide-footer
      :title="$t('alerta')"
      :no-close-on-backdrop="true"
    >
      <MessageBox :info="deletionNotAllowed" modelname="DeletionNotAllowed" />
    </b-modal>
  </div>
</template>

<script>
import FormGreatness from "./formGreatness.vue";
import * as cGridAll from "vue-cheetah-grid";
import * as cheetahGrid from "cheetah-grid";
import { defaultSuccess, urlMainAPI } from "@/global";
import MessageBox from "@/components/template/MessageBoxModal.vue";
import axios from "axios";
var vue;

export default {
  name: "GridGreatness",
  components: { ...cGridAll, FormGreatness, MessageBox },

  provide() {
    return {
      reloadGreatness: this.loadGreatness,
    };
  },

  data: function () {
    return {
      recebe: 0,
      record: 0,
      edit: 0,
      greatness: [],
      products: [],
      equipments: [],
      process: [],
      json: [],
      greatnessNotDelete: [],
      deletionNotAllowed: "",
      setNewData: false,
      temp: {},
      header: [
        {
          field: "product",
          caption: this.$t('produto-header'),
          action: "text",
          width: "29%",
          maxWidth: "50%",
          headerStyle: { textAlign: "justify", font: "15px sans-serif" },
          style: { textOverflow: "elipse" },
        },
        {
          field: "process",
          caption: this.$t('processo-header'),
          action: "text",
          width: "15%",
          maxWidth: "30%",
          headerStyle: { textAlign: "justify", font: "15px sans-serif" },
          style: { textOverflow: "elipse" },
        },
        {
          field: "equipment",
          caption: this.$t('equipamento-header'),
          action: "text",
          width: "15%",
          maxWidth: "30%",
          headerStyle: { textAlign: "justify", font: "15px sans-serif" },
          style: { textOverflow: "elipse" },
        },
        {
          field: "name",
          caption: this.$t('grandeza-header'),
          action: "text",
          minWidth: "15%",
          width: "33.322%",
          maxWidth: "41%",
          headerStyle: { textAlign: "justify", font: "15px sans-serif" },
          style: { textOverflow: "elipse" },
        },
        {
          width: "43px",
          minWidth: "43px",
          maxWidth: "43px",
          headerStyle: { textAlign: "justify", font: "15px sans-serif" },
          style: { textOverflow: "elipse" },
          icon: {
            font: "normal normal normal 28px/1 FontAwesome",
            content: "\uf040",
            width: 28, // Optional
          },
          columnType: new cheetahGrid.columns.type.ButtonColumn({
            caption: "",
          }),
          action: new cheetahGrid.columns.action.ButtonAction({
            action(rec) {
              vue.askAddGreatness(rec);
            },
          }),
        },
        {
          width: "43px",
          minWidth: "43px",
          maxWidth: "43px",
          headerStyle: { textAlign: "justify", font: "15px sans-serif" },
          style: { textOverflow: "elipse" },
          icon: {
            font: "normal normal normal 28px/1 FontAwesome",
            content: "\uf1f8",
            width: 28, // Optional
          },
          columnType: new cheetahGrid.columns.type.ButtonColumn({
            caption: "",
          }),
          action: new cheetahGrid.columns.action.ButtonAction({
            action(rec) {
              vue.temp = rec;
              vue.$bvModal.show('confirmDeleteData');
            },
          }),
        },
      ],
    };
  },
  watch: {
    recebe() {
      this.loadGreatness();
    },
  },
  methods: {
    async loadGreatness() {
      defaultSuccess(this.$t('carregando-grandezas'));
      const url = `${urlMainAPI}/getgreatness`;
      axios
        .get(url)
        .then(async (res) => {
          if(!res.data)
          return

          res.data.sort((d1, d2) => {
            if(d1.product < d2.product)
              return -1

            if(d1.product > d2.product)
              return 1
            return 0
          })
          
          this.greatness = res.data;
          this.json = res.data;
          this.setGrid(this.json);

          defaultSuccess(this.$t('grandezas-carregadas'));
        })
        .catch(console.log);
    },

    createGrid() {
      const grid = new cheetahGrid.ListGrid({
        parentElement: document.querySelector(".sample1"),
        allowRangePaste: true,
        header: this.header,
      });

      this.setGrid = function (table = this.json) {
        grid.records = table;
      };
    },

    askAddGreatness(rec) {
      if (rec != null) {
        this.setNewData = false;
        this.record = rec;
      } else {
        this.setNewData = true;
        this.record = {
          equipment: "",
          equipmentId: null,
          greatness: null,
          lowerThreshould: 0,
          name: "",
          process: null,
          processId: null,
          product: null,
          productId: null,
          unit: "",
          upperThreshould: 0,
        };
      }
      this.$bvModal.show("addingGreatness");
    },

    addLine(param) {
      this.greatness.push({
        productId: "",
        equipmentId: "",
        processId: "",
        name: param,
      });
    },

    deleteGreatness(greatness) {
      console.log('greatness :>> ', greatness);

      const url = `${urlMainAPI}/deletegreatness/${greatness.productId}/${greatness.processId}/${greatness.equipmentId}`;
      axios.get(url).then((res) => {
        this.greatnessNotDelete = res.data.greatnessNotDelete;
        if(this.greatnessNotDelete.length > 0) {
          let text = `A(s) grandeza(s):`;
          this.greatnessNotDelete.forEach((gt) => {
            text += ` ${gt.name == '' ? '[vazio]' : gt.name}; `;
          });
          text += `não pode(m) ser removida(s),`
          text += ` pois possui(em) análise(s) lançada(s).`;
          this.deletionNotAllowed = text;
          this.$bvModal.show("DeletionNotAllowed");
        } else {
          defaultSuccess(this.$t('grandeza-s-removida-s-com-sucesso'))
        }
        this.loadGreatness();
      });
    },
  },

  created() {
    this.loadGreatness();
    vue = this;
  },

  mounted() {
    this.createGrid();
  },
};
</script>

<style scoped>
.grid {
  width: 80vw;
  height: calc(80vh - 220px);
  /* width: 100%; */
  border: solid 1px rgba(0, 0, 0, 0.26);
  margin: 30px auto auto auto;
  overflow-x: hidden;
  overflow-y: auto;
}

.message {
  text-align: center;
  margin: 0;
  text-transform: uppercase;
  font-weight: bold;
}

.row {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 30px;
  /* margin-right: 70px; */
}

.group {
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 20px;
}

.gridBtGroup {
  margin: 30px auto auto auto;
  width: 80vw;
  display: flex;
  justify-content: flex-end;
}

.ybase {
  /* margin-right: 20px; */
  margin-top: 20x;
}

.gridBtGroup img {
  cursor: pointer;
  max-height: 45px;
}
</style>